import { View, isWeb, useMedia } from 'tamagui'
import { CoverImage } from '@components/CoverImage'
import { IProductVideoCover } from '@dtos/ProductPage'
import { getVideoEmbedUrl } from './helpers'

interface ICoverMediaProps {
  videoCover: IProductVideoCover | null
  imageUrl: string | null
  title: string | null
}

// Mídia do topo: vídeo de apresentação quando dá para embedar (web),
// senão a imagem de capa.
export function CoverMedia({ videoCover, imageUrl, title }: ICoverMediaProps) {
  const media = useMedia()
  const embedUrl = getVideoEmbedUrl(videoCover)

  if (isWeb && embedUrl) {
    return (
      <View
        width={media.gtSm ? 538 : '100%'}
        height={media.gtSm ? 303 : 200}
        borderRadius={4}
        overflow="hidden"
        testID="product-video-cover"
      >
        <iframe
          src={embedUrl}
          title={title ?? ''}
          style={{ width: '100%', height: '100%', border: 0 }}
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        />
      </View>
    )
  }

  const fallback = videoCover?.thumbnail || imageUrl
  if (!fallback) return null

  return (
    <CoverImage
      uri={fallback}
      alt={title ?? ''}
      width={media.gtSm ? 538 : '100%'}
      height={media.gtSm ? 303 : 200}
      borderRadius={4}
      eager
      testID="product-cover"
    />
  )
}
